import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AlertStateInterface } from '@app/core/app-services';
import { Alert } from '@app/core/domain';
import { AlertStore } from './alert.store';
import { AlertQuery } from './alert.query';

@Injectable()
export class AlertState implements AlertStateInterface {

  constructor(
    private store: AlertStore,
    private query: AlertQuery
  ) { }

  getAlerts(): Observable<Array<Alert>> {
    return this.query.selectAll();
  }

  setAlert(alert: Alert): void {
    this.store.upsert(alert.id, alert);
  }

  removeAlert(id: number): void {
    this.store.remove(id);
  }
}
